import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/apiClient";
import { waLink } from "@/data/site";
import { Star, MessageCircle } from "lucide-react";
import Seo from "@/components/Seo";

export default function Stories() {
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/stories", { params: { published: true } }).then((r) => setStories(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <Seo title="Customer Stories" description="Real journeys, real families — stories from travellers who explored India with VacanzaGo." />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="eyebrow">Customer Stories</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">Journeys, remembered</h1>
          <p className="mt-4 text-lg text-[#553204]">Real families, real trips — in their words.</p>
        </Reveal>
        <div className="space-y-16 lg:space-y-24">
          {stories.map((s, i) => (
            <Reveal key={s.id}>
              <div className={`grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center`}>
                <div className={`img-zoom rounded-md overflow-hidden aspect-[4/3] ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover" loading="lazy" />
                </div>
                <div className={i % 2 ? "md:order-1" : ""}>
                  <div className="flex gap-1 mb-3">{Array.from({ length: s.rating || 5 }).map((_, k) => <Star key={`star-${k}`} size={16} className="fill-[#F49E1A] text-[#F49E1A]" />)}</div>
                  <p className="eyebrow">{s.destination}</p>
                  <h2 className="font-display text-3xl sm:text-4xl font-medium mt-2 text-[#2A1808]">{s.family_name}</h2>
                  <p className="font-display italic text-2xl text-[#553204] mt-1">{s.title}</p>
                  <blockquote className="mt-5 text-xl font-display text-[#2A1808] leading-snug">"{s.quote}"</blockquote>
                  <p className="mt-4 text-[#553204] leading-relaxed">{s.story}</p>
                  {s.trip_slug && <Link to={`/packages/${s.trip_slug}`} className="inline-block mt-4 text-[#F49E1A] font-semibold text-sm">See their journey →</Link>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-20 text-center">
          <a href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full btn-orange px-7 py-3 text-sm"><MessageCircle size={16} /> Start your story</a>
        </div>
      </div>
    </div>
  );
}
